
import { Stack } from 'ui/stack';

import Button from 'components/partials/button/button';

import Icons from 'assets/icons';

export interface MonitoringErrorNoticeProps {
  message: string;
  onRetry: () => void;
}

// Shared inline error state for the dashboard's three independent queries
// (filter options, CE roster, dashboard metrics) — each can fail on its own,
// so each renders this instead of an endless spinner or a silent empty state.
const MonitoringErrorNotice = ({
  message,
  onRetry,
}: MonitoringErrorNoticeProps) => (
  <Stack
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      gap: 1,
      p: 2.5,
      bgcolor: 'tokens.navy.50',
      borderRadius: '0.5rem',
    }}
  >
    <Icons.Warning className="size-7 text-critical-500" aria-hidden="true" />
    <p className="font-semibold text-gray-700">{message}</p>
    <Button variant="reserve-outlined" size="sm" onClick={onRetry}>
      Retry
    </Button>
  </Stack>
);

export default MonitoringErrorNotice;
